module.exports = __webpack_public_path__ + "media/application/images/icons/icon-monitoring-1a4848971c368ef57837c7154fea391e.svg";